export default "__VITE_ASSET__2517941d__"